import { actionTypes as dataFetchActionTypes } from '@bufferapp/async-data-fetch';
import { actionTypes as profileSidebarActionTypes } from '~/profile-sidebar/reducer';
import { actionTypes as queueActionTypes } from '~/queue/reducer';
import keyWrapper from '@bufferapp/keywrapper';

export const actionTypes = keyWrapper('SENT', {
  FETCH_PENDING_TIKTOK_POSTS: 0,
  VIEW_CAMPAIGN_PAGE: 0,
});

export const initialState = {
  byProfileId: {},
};

export const profileInitialState = {
  loading: true,
  loadingMore: false,
  moreToLoad: false,
  page: 1,
  posts: {},
  total: 0,
};

const handlePosts = (action, currentPosts) => {
  let posts = action.result.updates;
  if (action.args.isFetchingMore) {
    posts = { ...currentPosts, ...posts };
  }
  return posts;
};

const increasePageCount = (page) => {
  page += 1;
  return page;
};

const determineIfMoreToLoad = (action, currentPosts) => {
  const currentPostCount = Object.keys(currentPosts).length;
  const resultUpdatesCount = Object.keys(action.result.updates).length;
  return action.result.total > currentPostCount + resultUpdatesCount;
};

// TODO: dedup from the others
const getProfileId = (action) => {
  if (action.profileId) {
    return action.profileId;
  }
  if (action.args) {
    return action.args.profileId;
  }
  if (action.profile) {
    return action.profile.id;
  }
};

// TODO: dedup from the others
const getPostUpdateId = (action) => {
  if (action.updateId) {
    return action.updateId;
  }
  if (action.args) {
    return action.args.updateId;
  }
  if (action.post) {
    return action.post.id;
  }
};

const postsReducer = (state, action) => {
  switch (action.type) {
    case queueActionTypes.POST_SENT:
      return {
        ...state,
        [getPostUpdateId(action)]: action.post,
      };
    default:
      return state;
  }
};

const hasBitlyPosts = (posts) =>
  Object.values(posts).some(
    (post) =>
      post.text.indexOf('https://buff.ly/') >= 0 ||
      post.text.indexOf('https://bit.ly/') >= 0 ||
      post.text.indexOf('https://j.mp/') >= 0
  );

const profileReducer = (state = profileInitialState, action) => {
  switch (action.type) {
    case profileSidebarActionTypes.SELECT_PROFILE:
      return profileInitialState;
    case `pendingTiktok_${dataFetchActionTypes.FETCH_START}`:
      return {
        ...state,
        loading: !action.args.isFetchingMore,
        loadingMore: action.args.isFetchingMore,
      };
    case `pendingTiktok_${dataFetchActionTypes.FETCH_SUCCESS}`: {
      const posts = handlePosts(action, state.posts);

      return {
        ...state,
        loading: false,
        loadingMore: false,
        moreToLoad: determineIfMoreToLoad(action, posts),
        page: increasePageCount(state.page),
        posts,
        total: action.result.total,
        hasBitlyPosts: hasBitlyPosts(posts),
      };
    }
    case `pendingTiktok_${dataFetchActionTypes.FETCH_FAIL}`:
      return {
        ...state,
        loading: false,
      };
    case queueActionTypes.POST_SENT: {
      const updateTotal = action.type === queueActionTypes.POST_SENT;
      return {
        ...state,
        total: updateTotal ? state.total + 1 : state.total,
        posts: postsReducer(state.posts, action),
      };
    }
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  let profileId;
  switch (action.type) {
    case profileSidebarActionTypes.SELECT_PROFILE:
    case `pendingTiktok_${dataFetchActionTypes.FETCH_START}`:
    case `pendingTiktok_${dataFetchActionTypes.FETCH_SUCCESS}`:
    case `pendingTiktok_${dataFetchActionTypes.FETCH_FAIL}`:
    case queueActionTypes.POST_SENT:
    case queueActionTypes.POST_COUNT_UPDATED:
      profileId = getProfileId(action);
      if (profileId) {
        return {
          ...state,
          byProfileId: {
            ...state.byProfileId,
            [profileId]: profileReducer(state.byProfileId[profileId], action),
          },
        };
      }
      return state;
    default:
      return state;
  }
};

export const actions = {
  handleCampaignTagClick: ({ campaignId }) => ({
    type: queueActionTypes.VIEW_CAMPAIGN_PAGE,
    campaignId,
    isSent: true,
  }),
  fetchPendingTiktokPosts: ({ profileId }) => {
    return {
      type: actionTypes.FETCH_PENDING_TIKTOK_POSTS,
      profileId,
    };
  },
};
